export var convertPhcpToString = function (hcp) {
    var hcpString = (hcp === null || hcp === void 0 ? void 0 : hcp.toFixed(0)) || '';
    if (hcp) {
        hcpString = hcp > 0 ? "+".concat(hcpString) : hcpString.replace('-', '');
    }
    return hcpString;
};
export var convertHcpToString = function (hcp) {
    var hcpString = (hcp === null || hcp === void 0 ? void 0 : hcp.toFixed(1)) || '';
    if (hcp) {
        hcpString = hcp > 0 ? "+".concat(hcpString) : hcpString.replace('-', '');
    }
    return hcpString;
};
